// Components==============
import { AnimatePresence, motion } from 'framer-motion';
import React, { useContext, useEffect } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import './Tooltip.module.scss';
import { initialTooltipProps, TooltipContext } from './TooltipContextWrapper';
// =========================

export default function Tippy() {
  const {
    tooltipIsVisible,
    setTooltipIsVisible,
    tooltipPosition,
    setTooltipPosition,
    tooltipProps,
    setTooltipProps,
  } = useContext(TooltipContext);

  const { position, content, noPointer } = tooltipProps;

  useEffect(() => {
    if (!tooltipIsVisible) {
      setTooltipPosition({ top: 0, left: 0 });
      setTooltipProps(initialTooltipProps);
    }
  }, [tooltipIsVisible]);

  // Listen to any scroll event if the tooltip is open. If it is open, close the tooltip
  useEffect(() => {
    if (tooltipIsVisible) {
      const handleScroll = () => {
        setTooltipIsVisible(false);
      };
      window.addEventListener('scroll', handleScroll, true);

      return () => window.removeEventListener('scroll', handleScroll, true);
    }
  }, [tooltipIsVisible]);

  return (
    <AnimatePresence>
      {tooltipIsVisible && (
        <motion.div
          {...framerFade}
          transition={{ duration: 0.2 }}
          style={{
            position: 'fixed',
            top: tooltipPosition.top,
            left: tooltipPosition.left,
            zIndex: 300,
          }}
          onHoverStart={
            tooltipProps.clicked ? undefined : () => setTooltipIsVisible(true)
          }
          onHoverEnd={() => setTooltipIsVisible(false)}
        >
          <div
            styleName={`tooltip-content ${position} `}
            style={{
              pointerEvents: noPointer
                ? 'none'
                : tooltipIsVisible
                ? 'all'
                : 'none',
            }}
          >
            {content}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
